module.exports = __webpack_public_path__ + "img/bedroom-seating.72052e5.jpg";